import { useState } from "react";
import { PropTypes } from 'prop-types';
import ModelButton from "../../modelBtn/modelButton";
import EventPopUp from "./eventPopUp";

const EventCard = ({ event }) => {
    const [modalOpen, setModalOpen] = useState(false);

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);
    return (
        event?.children ?
            <>
                <div
                    className="flex flex-col items-center justify-center md:flex-row md:items-start gap-5  md:justify-start cursor-pointer"
                    onClick={
                        () => (modalOpen ? closed() : open())
                    }
                >
                    <div className="w-48 h-48 md:w-28 md:h-24 bg-center bg-cover bg-no-repeat " style={{ backgroundImage: `url('${event.img}')` }}>

                    </div>
                    <div className="flex flex-col gap-2 pt-2 items-center justify-center md:items-start md:justify-start">
                        <span className="text-neutral-700 text-xs font-normal text-center md:text-left leading-3">
                            {event.author}
                        </span>
                        <h2 className="text-neutral-700 text-base font-medium text-center md:text-left">
                            {event.title}
                        </h2>
                    </div>
                </div>
                <ModelButton modalOpen={modalOpen} close={closed}>
                    <EventPopUp title={event.title} date={event.date} description={event.children} />
                </ModelButton>
            </>
            :
            <div
                className="flex flex-col items-center justify-center md:flex-row md:items-start gap-5  md:justify-start"
            >
                <div className="w-48 h-48 md:w-28 md:h-24 bg-center bg-cover bg-no-repeat " style={{ backgroundImage: `url('${event.img}')` }}>

                </div>
                <div className="flex flex-col gap-2 pt-2 items-center justify-center md:items-start md:justify-start">
                    <span className="text-neutral-700 text-xs font-normal text-center md:text-left leading-3">
                        {event.author}
                    </span>
                    <h2 className="text-neutral-700 text-base font-medium text-center md:text-left">
                        {event.title}
                    </h2>
                </div>
            </div>
    )
}
EventCard.propTypes = {
    event: PropTypes.any
}
export default EventCard